const rankingItems = [
  { rank: 1, title: '某顶流男星被曝隐婚生子，工作室紧急回应', heat: '🔥 128万', change: 'up' },
  { rank: 2, title: '网红主播直播翻车，口误引发连锁反应', heat: '🔥 106万', change: 'up' },
  { rank: 3, title: '某品牌代言人风波：官宣后24小时内解约', heat: '🔥 94万', change: 'new' },
  { rank: 4, title: '综艺节目录制现场突发状况全记录', heat: '🔥 87万', change: 'up' },
  { rank: 5, title: '音乐圈抄袭争议升级，多方回应各执一词', heat: '🔥 73万', change: 'down' },
  { rank: 6, title: '影视剧番位之争再起波澜，粉丝集体抗议', heat: '🔥 65万', change: 'up' },
  { rank: 7, title: '体育明星私生活曝光，当事人发文回应', heat: '🔥 58万', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热度榜单
            </h2>
            <span className="text-xs text-foreground-500">每小时更新</span>
          </div>
          <p className="text-sm text-foreground-600 mb-8">
            全网吃瓜群众关注度最高的热门事件排行
          </p>
          <div className="space-y-2">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-100 rounded-lg cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-primary-400 text-white'
                      : item.rank === 3
                      ? 'bg-accent-400 text-white'
                      : 'bg-secondary-200 text-secondary-700'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs md:text-sm font-medium text-primary-600 whitespace-nowrap">
                    {item.heat}
                  </span>
                  <i
                    className={`text-sm ${
                      item.change === 'up'
                        ? 'ri-arrow-up-line text-primary-500'
                        : item.change === 'new'
                        ? 'ri-sparkling-line text-accent-500'
                        : 'ri-arrow-down-line text-secondary-500'
                    }`}
                  ></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}